document.addEventListener('DOMContentLoaded', function () {
    let tooltip = null;

    document.addEventListener('mouseover', function (e) {
        const trigger = e.target.closest('[data-tooltip-text]');
        if (!trigger) return;
        const text = trigger.getAttribute('data-tooltip-text');
        if (!text) return;

        tooltip = document.createElement('div');
        tooltip.className = 'js-tooltip';
        tooltip.textContent = text;
        document.body.appendChild(tooltip);

        const rect = trigger.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();
        let top = rect.bottom + window.scrollY + 8;
        let left = rect.left + window.scrollX + rect.width / 2 - tooltipRect.width / 2;
        tooltip.style.top = top + 'px';
        tooltip.style.left = left + 'px';
    });

    document.addEventListener('mouseout', function (e) {
        if (tooltip) {
            tooltip.remove();
            tooltip = null;
        }
    });
});
